// ERP escolhido nas telas "por ERP" do interno (resumo, tickets, atendimentos,
// dash de atendimentos, financeiro, Central de Alertas), lembrado no navegador:
// escolher IXC numa delas mantém IXC nas outras. Só conveniência — sem
// localStorage (ou com um id que não está mais na lista), vale o padrão.
const CHAVE = "erpSelecionado";

/** ERP inicial da lista: o lembrado (se `lembrar`), senão HubSoft, senão o primeiro. */
export function erpInicial(lista, lembrar = true) {
  let lembrado = null;
  try {
    if (lembrar) lembrado = localStorage.getItem(CHAVE);
  } catch {}
  return (
    lista.find((erp) => erp.id === lembrado) ||
    lista.find((erp) => erp.tipo === "HUBSOFT") ||
    lista[0] ||
    null
  );
}

export function lembrarErp(erpId) {
  try {
    if (erpId) localStorage.setItem(CHAVE, erpId);
  } catch {}
}
